(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pop-byor"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function () {
     $(".launch-byor").click(function () {
         $(".pop").fadeIn(300);
        $(".overlay").fadeIn(200);
        
     });

     $(".pop > .close, .pop").click(function () {
         $(".pop").fadeOut(300);
       $(".overlay").fadeOut(200);
     });
 });

  } catch(e) { console.error(e); }
})();
})();
